import ATextButton from './a-text-button.vue';

export default ATextButton;